import React from 'react';
import { Card } from 'antd';
import cx from 'classnames';

import { InternalRecruiterResponseModel } from 'api/backofficeApiClient';

import styles from './RecruiterCard.module.less';

type Props = {
  recruiter: InternalRecruiterResponseModel;
};

export default function RecruiterCard(props: Props) {
  const { recruiter } = props;
  const { firstName, lastName } = recruiter;

  return (
    <Card className={cx('card-item size-sm stretch-card', styles.root)}>
      <div className="card-inner h-centered">
        <div className="inner-text-box">
          <span className="card-title">
            {firstName} {lastName}
          </span>
        </div>

        {/* For button */}
        {/* <div className="inner-right-box"></div> */}
      </div>
    </Card>
  );
}
